/**
 * Shared UI Layer Validation Types
 * Used across DragDropZone, Editor Tools, and other components
 */

/**
 * Validation error structure
 */
export interface ValidationError {
  field: string
  message: string
  type: 'error' | 'warning' | 'info'
  meta?: Record<string, unknown>
}

/**
 * Utility function to format bytes
 */
export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

/**
 * Utility function to check if file type matches pattern
 */
export const matchesFileType = (fileType: string, pattern: string): boolean => {
  if (pattern.endsWith('/*')) {
    // Match wildcard patterns like 'image/*'
    return fileType.startsWith(pattern.slice(0, -2))
  }
  return fileType === pattern
}

